import React from 'react';
import '../style/index.css';
import { Route, Switch, withRouter } from 'react-router-dom';
import { Header } from './common/components/Header';
import { Footer } from './common/components/Footer';
import { TitleSection } from './common/components/TitleSection';
import { getCopy, getPageTitle } from './common/lib/copyDefaults';
import Register from './views/register';
import CompleteRegistration from './views/complete-registration';
import CheckEmail from './views/checkEmail';
import Login from './views/login';
import ForgotPassword from './views/forgotPassword';
import ConfirmResetPassword from './views/confirmResetPassword';
import VerifyEmail from './views/verifyEmail';
import UpdateProfile from './views/updateProfile';
import MigrateExistingUser from './views/migrateExistingUser';
import MigrationFailed from './views/migrationFailed';
import MigrationSuccess from './views/migrationSuccess';
import UserDuplicated from './views/userDuplicated';
import IdentityVerification from './views/identityVerification';
import GovIdResponse from './views/govIdResponse';

/**
 * This transforms the location.pathname into a usable CSS className to be used
 * for the container element of the `<Header />` component.
 */
const transformPathNameToHeaderClassName = (pathname) => {
  // Remove leading slash if it exists
  const pageName = pathname.replace(/^\//, '');

  // replace all remaining slashes with underscores
  return `header--${pageName.replace(/\//g, '_')}`;
};

const HeaderWithRouter = withRouter((props) => {
  const headerClassName = transformPathNameToHeaderClassName(props.location.pathname);
  return <Header {...props} headerClassName={headerClassName} />;
});

const RoutedTitleSection = withRouter(({ location }) => {
  const copy = getCopy(location.pathname);
  const showTitleSection = copy.header && copy.routedTitleSection !== false;

  return (
    <TitleSection
      pageTitle={getPageTitle(location.pathname)}
      title={showTitleSection ? copy.header : ''}
      body={showTitleSection ? copy.body : ''}
      line2={showTitleSection ? copy.line2 : ''}
      linkPreText={showTitleSection ? copy.preLinkText : ''}
      linkText={showTitleSection ? copy.linkText : ''}
      linkPostText={showTitleSection ? copy.postLinkText : ''}
      linkUrl={showTitleSection ? copy.linkUrl : ''}
    />
  );
});

const RegisterWithRouter = withRouter((props) => <Register {...props} />);
const CompleteRegistrationWithRouter = withRouter((props) => <CompleteRegistration {...props} />);
const CheckEmailWithRouter = withRouter((props) => <CheckEmail {...props} />);
const LoginWithRouter = withRouter((props) => <Login {...props} />);
const GovIdResponseWithRouter = withRouter((props) => <GovIdResponse {...props} />);

const Routes = (
  <div className="app-container">
    <HeaderWithRouter />
    <div className="container-wrap container-fluid">
      <RoutedTitleSection />
      <div className="container-wrap__content">
        <Switch>
          <Route exact path="/register" component={RegisterWithRouter} />
          <Route exact path="/complete-registration" component={CompleteRegistrationWithRouter} />
          <Route exact path="/login" component={LoginWithRouter} />
          <Route exact path="/reset-password" component={ForgotPassword} />
          <Route exact path="/confirm-reset-password" component={ConfirmResetPassword} />
          <Route exact path="/check-email" component={CheckEmailWithRouter} />
          <Route exact path="/verify-email" component={VerifyEmail} />
          <Route exact path="/update-profile" component={UpdateProfile} />
          <Route exact path="/gov-id-response" component={GovIdResponseWithRouter} />
          <Route exact path="/user-duplicated" component={UserDuplicated} />
          <Route exact path="/idv/migrate" component={MigrateExistingUser} />
          <Route exact path="/idv/failed" component={MigrationFailed} />
          <Route exact path="/idv/success" component={MigrationSuccess} />
          <Route exact path="/idv/identity-verification" component={IdentityVerification} />
          <Route path="*" component={RegisterWithRouter} />
        </Switch>
      </div>
    </div>
    <Footer />
  </div>
);

export default Routes;
